import { createSlice } from "@reduxjs/toolkit"

const initialState = {}

const messagesSlice = createSlice({
    name: 'messages',
    initialState,
    reducers: {}
})

export default messagesSlice.reducer;
export const {} = messagesSlice.actions;